
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#FF4368","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M8.594 6.463zm3.819.707c.286.352.428.767.428 1.245 0 .342-.098.671-.293.989-.107.18-.248.354-.424.52l-.586.579c-.562.552-.925 1.041-1.09 1.469-.167.427-.25.99-.25 1.688h1.304c0-.615.07-1.08.209-1.395.139-.315.443-.699.912-1.154.645-.625 1.073-1.099 1.285-1.421.212-.322.319-.742.319-1.26 0-.854-.289-1.556-.868-2.106-.579-.55-1.349-.824-2.311-.824-1.04 0-1.858.321-2.454.963-.596.642-.894 1.49-.894 2.545h1.304c.024-.635.125-1.121.3-1.458.312-.605.876-.908 1.692-.908.659 0 1.132.176 1.417.528zm-.787 7.705h-1.458v1.523h1.458z"}}),_c('path',{attrs:{"d":"M22 11c0-6.075-4.925-11-11-11S0 4.925 0 11s4.925 11 11 11 11-4.925 11-11zM1 11C1 5.477 5.477 1 11 1s10 4.477 10 10-4.477 10-10 10S1 16.523 1 11z"}})])])
          )
        }
      }
    